import { useNavigate, useParams } from "react-router-dom";

export const useRefreshCurrentRoute = () => {
	const navigate = useNavigate();
	const { locale } = useParams();
	return () => navigate(`/${locale}/refresh`)
}